import React from 'react';
import Comment from './comment';

export default function CommentList({ comments, loading }) {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
        <span style={{ fontSize: '12px', color: '#585969', fontWeight: 500 }}>
          {comments.length} comment{comments.length !== 1 ? 's' : ''}
        </span>
        {comments.length > 0 && (
          <span style={{ background: '#E5E9FE', color: '#6C5DD3', fontSize: '11px', fontWeight: 700, borderRadius: '10px', padding: '1px 8px' }}>
            {comments.length}
          </span>
        )}
      </div>

      {comments.length === 0 && !loading ? (
        <div style={{ textAlign: 'center', padding: '24px 0', color: '#A5A6BB', fontSize: '13px' }}>
          <div style={{ fontSize: '24px', marginBottom: '6px' }}>💬</div>
          No comments yet
        </div>
      ) : (
        <div style={{ maxHeight: '50vh', overflowY: 'auto', paddingRight: '4px' }}>
          {comments.slice().reverse().map((comment, index) => (
            <Comment key={index} comment={comment} />
          ))}
        </div>
      )}
    </div>
  );
}
